import React from 'react';
import './App.css';
import NavBar from './NavBar';
import Body from './Body';

function App() {
  return (
    <div>
      <NavBar/>
      <Body/>
    </div>
  );
}

export default App;
